import { z } from "zod";

export const REPORTING_SCOPES = ["reporting-line", "direct-reports", "organization"] as const;
export const ReportingScopeSchema = z.enum(REPORTING_SCOPES);
export type ReportingScope = z.infer<typeof ReportingScopeSchema>;

export const DEFAULT_REPORTING_SCOPE: ReportingScope = "reporting-line";

const ScopeMemberSchema = z.object({
    id: z.string(),
    displayName: z.string(),
    imageUrl: z.string().optional()
});

const ScopePreviewSchema = z.object({
    previewMembers: z.array(ScopeMemberSchema),
    totalCount: z.number()
});

export const ScopePreviewsSchema = z.object({
    reportingLine: ScopePreviewSchema,
    directReports: ScopePreviewSchema,
    organization: ScopePreviewSchema
});

export type ScopeMember = z.infer<typeof ScopeMemberSchema>;
export type ScopePreview = z.infer<typeof ScopePreviewSchema>;
export type ScopePreviews = z.infer<typeof ScopePreviewsSchema>;

export const PREVIEW_SIZE = 5;
